'use strict';

var _ = require('lodash');
function BookingsIntakeModalFieldUtilService() {
  var validFieldNames = ['regularBookingsIntake', 'mappedBookingsIntake', 'segClassBookingsIntake', 'legClassBookingsIntake', 'bookingsIntake'];
  var selectedFieldName;
  function sanitizeFieldName(fieldName) {
    return _.replace(fieldName, /(Html|Data)/g, '');
  }
  function setFieldName(fieldName) {
    var sanitizedFieldName = sanitizeFieldName(fieldName);
    if (validFieldNames.indexOf(sanitizedFieldName) === -1) {
      selectedFieldName = null;
      return;
    }
    selectedFieldName = sanitizedFieldName;
  }
  function getFieldName() {
    return selectedFieldName;
  }
  function getDataFieldName() {
    return getFieldName() + 'Data';
  }
  function getGridFieldName() {
    return getFieldName() + 'Html';
  }
  return {
    setFieldName: setFieldName,
    getFieldName: getFieldName,
    getDataFieldName: getDataFieldName,
    getGridFieldName: getGridFieldName
  };
}
BookingsIntakeModalFieldUtilService.$inject = [];
module.exports = BookingsIntakeModalFieldUtilService;